import { type ReactNode, useContext } from 'react';
import { AuthContext } from '../contexts/auth-context-provider';
import { type Roles } from '../types';

const AuthorizedComponent = (props: {
  children: ReactNode | ReactNode[];
  roles?: Roles[];
  redirect?: boolean;
}): ReactNode => {
  const { children, roles, redirect } = props;
  const { isAuthenticated, navigateToLogin, returnToApp, session } = useContext(AuthContext);
  // const memoChildren = useMemo(() => children, [session]);

  const isInOneOfRoles = (roles: Roles[] | null): boolean =>
    (roles == null || (session?.claims && roles.includes(session.claims.role))) ?? false;

  // not authenticated
  if (!isAuthenticated) {
    return navigateToLogin;
  }
  // not authorized
  if (!isInOneOfRoles(roles ?? null)) {
    return redirect ? returnToApp : null;
  }
  // ok
  return children;
};

AuthorizedComponent.defaultProps = {
  roles: undefined,
  redirect: false,
};

export default AuthorizedComponent;
